var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('input',{attrs:{"type":"text"}}),_c('img',{staticClass:"search",attrs:{"src":"/static/Image/home/search.png"}}),_c('login'),_c('div',{staticClass:"handle-one"},[_c('router-link',{staticClass:"handle-icon fav-icon",attrs:{"to":"/account/myFavorite"}})],1),_c('shopcart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }